import { Component, Injector, OnInit } from '@angular/core';
import { ContratoService } from 'administrativo-lib';
import { BaseResourceListComponent, Coluna, Contrato, Filtro, FormatoExportacao, FuncaoService, GlobalService, LoginContabil } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-contrato-list',
  templateUrl: './contrato-list.component.html'
})
export class ContratoListComponent extends BaseResourceListComponent<Contrato, LoginContabil> implements OnInit {

  /**
   * Declaração de variáveis
   */

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    public globalService: GlobalService,
    public funcaoService: FuncaoService,
    private contratoService: ContratoService) {
    super(contratoService, injector);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected relations(): string {
    return 'orgao,favorecido,tipo_contratacao';
  }

  protected condicoesGrid(): {} {
    return {
      ['orgao.id']: this.login.orgao.id
    };
  }

  protected ordenacaoGrid(): string[] {
    return ['data_inicio$DESC'];
  }

  protected filtrosGrid(): Filtro {
    return {
      number: ['numero', 'aditivo', 'valor_contrato'],
      date: ['data_inicio', 'data_termino'],
      text: ['favorecido.nome','tipo_contratacao.nome'],
    };
  }

  protected afterInit(): void {
  }

  protected acaoRemover(model: Contrato): Observable<Contrato> {
    return null;
  }

  protected colunasRelatorio(): string[] | Coluna[] {
    return [
      { titulo: 'Número', coluna: 'numero', bold: true },
      { titulo: 'Fornecedor', coluna: 'favorecido.nome' },
      { titulo: 'Tipo Contratação', coluna: 'tipo_contratacao.nome' },
      { titulo: 'Objeto', coluna: 'objeto' },
      { titulo: 'Início', coluna: 'data_inicio' },
      { titulo: 'Término', coluna: 'data_termino' },
      { titulo: 'Valor', coluna: 'valor_contrato', decimais: 2, alignment: 'right' },
    ];
  }

  public exportarListagem(formato: FormatoExportacao) {
    const parametros = this.obterParametros();
    parametros['relations'] = 'orgao,favorecido';
    this.contratoService
      .filtrar(1, -1,
        parametros
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        lista => {
          if (formato === 'pdf') {
            this.imprimir('LISTAGEM DE CONTRATOS',
              this.login.usuario.nome, this.login.orgao.nome, this.login.brasao, 'landscape',
              'Listagem contratos', ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'], lista.content);
          } else {
            this.exportar(formato, lista.content);
          }
        },
        () => alert('erro ao retornar lista')
      );
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

}
